import React from 'react';

import { Loader } from '../../components/Loader';

import { ContextualLoadingView } from './ContextualLoadingView';
import type { LoadingConfig } from './index';
import { LoadingViewContainer } from './styledComponents';

interface LoadingViewProps {
  loadingConfig?: LoadingConfig;
}

class LoadingView extends React.Component<LoadingViewProps> {

  renderDefaultLoadingView = () => {
    return (
      <LoadingViewContainer className="loading-view-container">
        <Loader height={40} width={40} />
      </LoadingViewContainer>
    );
  };

  override render() {
    const { loadingConfig } = this.props;
    const shouldRenderDefaultView =
      !loadingConfig ||
      loadingConfig.variant === 'default'

    if (shouldRenderDefaultView) {
      return this.renderDefaultLoadingView();
    }

    return <ContextualLoadingView config={loadingConfig} />;
  }
}

export { LoadingView };
